// extracted by mini-css-extract-plugin
export default {"operation":"index_operation__ZDPPT"};